import {
  DS_INLINE_TOKEN_GROUP_EDGE,
  DS_INLINE_TOKEN_VARIANT,
  DSInlineTokenGroupEdge,
  DSInlineTokenVariant,
} from "@/src/design_system/data_display/inline_token/types/props";

export const DS_INLINE_TOKEN_CLASSES = {
  Root: "ds-inline-token",
  Prefix: "ds-inline-token__prefix",
  Text: "ds-inline-token__text",
  Label: "ds-inline-token__label",
  VariantDefault: "ds-inline-token--default",
  VariantRaised: "ds-inline-token--raised",
  VariantPrimary: "ds-inline-token--primary",
  VariantNeutral: "ds-inline-token--neutral",
  VariantDanger: "ds-inline-token--danger",
  VariantGhost: "ds-inline-token--ghost",
  GroupStart: "ds-inline-token--group-start",
  GroupMiddle: "ds-inline-token--group-middle",
  GroupEnd: "ds-inline-token--group-end",
  GroupNoPadding: "ds-inline-token--no-padding",
} as const;

export const DS_INLINE_TOKEN_VARIANT_TO_CLASS_MAP: Record<DSInlineTokenVariant, string> = {
  [DS_INLINE_TOKEN_VARIANT.Default]: DS_INLINE_TOKEN_CLASSES.VariantDefault,
  [DS_INLINE_TOKEN_VARIANT.Raised]: DS_INLINE_TOKEN_CLASSES.VariantRaised,
  [DS_INLINE_TOKEN_VARIANT.Primary]: DS_INLINE_TOKEN_CLASSES.VariantPrimary,
  [DS_INLINE_TOKEN_VARIANT.Neutral]: DS_INLINE_TOKEN_CLASSES.VariantNeutral,
  [DS_INLINE_TOKEN_VARIANT.Danger]: DS_INLINE_TOKEN_CLASSES.VariantDanger,
  [DS_INLINE_TOKEN_VARIANT.Ghost]: DS_INLINE_TOKEN_CLASSES.VariantGhost,
} as const;

export const DS_INLINE_TOKEN_GROUP_EDGE_TO_CLASS_MAP: Record<DSInlineTokenGroupEdge, string | null> = {
  [DS_INLINE_TOKEN_GROUP_EDGE.Solo]: null,
  [DS_INLINE_TOKEN_GROUP_EDGE.Start]: DS_INLINE_TOKEN_CLASSES.GroupStart,
  [DS_INLINE_TOKEN_GROUP_EDGE.Middle]: DS_INLINE_TOKEN_CLASSES.GroupMiddle,
  [DS_INLINE_TOKEN_GROUP_EDGE.End]: DS_INLINE_TOKEN_CLASSES.GroupEnd,
  [DS_INLINE_TOKEN_GROUP_EDGE.NoPadding]: DS_INLINE_TOKEN_CLASSES.GroupNoPadding,
} as const;
